export enum TenantScreens {
  TENANT_ADMIN_SCREEN = 'TENANT_ADMIN_SCREEN',
}

export const ALL_SCREENS = [TenantScreens.TENANT_ADMIN_SCREEN] as const;

export enum TenantAdminTab {
  ORGANIZATIONS_TAB = 'ORGANIZATIONS_TAB',
  TEAMS_TAB = 'TEAMS_TAB',
  USERS_TAB = 'USERS_TAB',
  LICENSES_TAB = 'LICENSES_TAB',
  SETTINGS_TAB = 'SETTINGS_TAB',
  BENCHLING_APPS_TAB = 'BENCHLING_APPS_TAB',
  DATA_MODEL_TAB = 'DATA_MODEL_TAB',
}

export const TENANT_ADMIN_PAGE_SECTION_URL_PARAM_TO_TAB: {[key: string]: TenantAdminTab} = {
  organizations: TenantAdminTab.ORGANIZATIONS_TAB,
  teams: TenantAdminTab.TEAMS_TAB,
  users: TenantAdminTab.USERS_TAB,
  licenses: TenantAdminTab.LICENSES_TAB,
  settings: TenantAdminTab.SETTINGS_TAB,
  apps: TenantAdminTab.BENCHLING_APPS_TAB,
  dataModel: TenantAdminTab.DATA_MODEL_TAB,
};

export const TENANT_ADMIN_PAGE_TAB_TO_SECTION_URL_PARAM: {[key in TenantAdminTab]: string} = {
  ORGANIZATIONS_TAB: 'organizations',
  TEAMS_TAB: 'teams',
  USERS_TAB: 'users',
  LICENSES_TAB: 'licenses',
  SETTINGS_TAB: 'settings',
  BENCHLING_APPS_TAB: 'apps',
  DATA_MODEL_TAB: 'dataModel',
};

export const TENANT_ADMIN_TAB_TO_READABLE: {[key in TenantAdminTab]: string} = {
  ORGANIZATIONS_TAB: 'Organizations',
  TEAMS_TAB: 'Teams',
  USERS_TAB: 'Users',
  LICENSES_TAB: 'Licenses',
  SETTINGS_TAB: 'Settings',
  BENCHLING_APPS_TAB: 'Apps',
  DATA_MODEL_TAB: 'Data Model',
};

export enum TenantAdminSettingsTab {
  GENERAL_SETTINGS_TAB = 'GENERAL_SETTINGS_TAB',
  CONFIGURATIONS_TAB = 'CONFIGURATIONS_TAB',
  DATA_MODIFICATIONS_TAB = 'DATA_MODIFICATIONS_TAB',
  PERMISSION_CONTROLS_TAB = 'PERMISSION_CONTROLS_TAB',
  AUTHENTICATION_TAB = 'AUTHENTICATION_TAB',
  IP_ALLOWLISTS_TAB = 'IP_ALLOWLISTS_TAB',
  LLM_FEATURES_TAB = 'LLM_FEATURES_TAB',
  APPLICATIONS_TAB = 'APPLICATIONS_TAB',
  INSIGHTS_TAB = 'INSIGHTS_TAB',
}

export const TENANT_ADMIN_SETTINGS_TAB_TO_READABLE: {[key in TenantAdminSettingsTab]: string} = {
  GENERAL_SETTINGS_TAB: 'General Settings',
  CONFIGURATIONS_TAB: 'Configurations',
  DATA_MODIFICATIONS_TAB: 'Data Modifications',
  PERMISSION_CONTROLS_TAB: 'Permission Controls',
  AUTHENTICATION_TAB: 'Authentication',
  IP_ALLOWLISTS_TAB: 'IP Allowlists',
  LLM_FEATURES_TAB: 'AI Settings',
  APPLICATIONS_TAB: 'Application Provisioning',
  INSIGHTS_TAB: 'Insights Labs',
};

export const TENANT_ADMIN_SETTINGS_TABS: Array<TenantAdminSettingsTab> = [
  TenantAdminSettingsTab.GENERAL_SETTINGS_TAB,
  TenantAdminSettingsTab.CONFIGURATIONS_TAB,
  TenantAdminSettingsTab.DATA_MODIFICATIONS_TAB,
  TenantAdminSettingsTab.PERMISSION_CONTROLS_TAB,
  TenantAdminSettingsTab.AUTHENTICATION_TAB,
  TenantAdminSettingsTab.IP_ALLOWLISTS_TAB,
  TenantAdminSettingsTab.LLM_FEATURES_TAB,
  TenantAdminSettingsTab.APPLICATIONS_TAB,
  TenantAdminSettingsTab.INSIGHTS_TAB,
];

export const ENABLE_COPY_API_ID: string = 'ENABLE_COPY_API_ID';

export enum FeatureStage {
  BETA = 'BETA',
  PREVIEW = 'PREVIEW',
  GA = 'GA',
}
